import { useEffect } from "react"

export const useVisibilityTracking = (
  setIsVisible: (visible: boolean) => void
) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === "visible")
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [setIsVisible])
}
